import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { errorText, getReports, loadingText, noResultsText } from "../../custom_api/api";
import { Jumbo } from "../components/jumbo";
import { Teasers } from "../components/teaser";
const reportOverviewPageStateZero = {
    reports: "loading"
};
export class ReportOverviewPage extends React.Component {
    componentDidMount() {
        if (this.state.reports == "loading") {
            getReports().then((reports)=>this.setState((s, _)=>reports !== "loading" && reports !== "error" ? {
                        ...s,
                        reports
                    } : s));
        }
        document.title = this.props.pageTitle;
    }
    render() {
        const reports = /*#__PURE__*/ _jsx("section", {
            className: "reports",
            children: this.state.reports == "loading" ? /*#__PURE__*/ _jsx("div", {
                className: "container--m align--center text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: loadingText
                })
            }) : this.state.reports == "error" ? /*#__PURE__*/ _jsx("div", {
                className: "container--m align--center text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: errorText
                })
            }) : this.state.reports.isEmpty() ? /*#__PURE__*/ _jsx("div", {
                className: "container--m align--center text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: noResultsText
                })
            }) : /*#__PURE__*/ _jsx(Teasers, {
                items: this.state.reports.map((r, k)=>({
                        key: `report-overview-item-${k}`,
                        headingLevel: 'h2',
                        title: r.title,
                        intro: r.shortDescription,
                        label: r.datetimes.count() == 1 ? /*#__PURE__*/ _jsx("time", {
                            dateTime: r.datetimes.first().format("L"),
                            children: r.datetimes.first().format("L")
                        }) : null,
                        linkUrl: r.url,
                        imageUrl: r.imageUrl,
                        imageUrlFallback: r.imageUrlFallback,
                        imageUrlLarge: r.imageUrlLarge,
                        imageAlt: r.imageAlt,
                        locationFooter: r.locations.count() == 1 ? r.locations.first() : 'Meerdere locaties'
                    })).toList()
            })
        });
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: this.props.headerTitle,
                    contents: this.props.description,
                    imageUrlSmall: this.props.jumboSize == 'small' && this.props.phImageUrlSmall ? this.props.phImageUrlSmall : undefined,
                    imageUrl: this.props.phImageUrl,
                    imageUrlFallback: this.props.phImageUrlFallback,
                    imageUrlLarge: this.props.phImageUrlLarge,
                    imageAlt: this.props.imageAlt,
                    buttonUrl: this.props.buttonUrl,
                    buttonTitle: this.props.buttonTitle,
                    size: this.props.jumboSize
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "container--lg align--center",
                    "aria-live": "polite",
                    children: reports
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = reportOverviewPageStateZero;
    }
}
{}